import React from 'react';
import './App.css'
function CustomButton({ btntitle, href }) {
  return (
    <a href={href} className="custom-button">
      {btntitle}
    </a>
  );
}

export default CustomButton;
